// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__At1tx","loader":"Loader_loader__g0WEH","loader-1":"Loader_loader-1__Mdbeo","loader-2":"Loader_loader-2__Wj_kh"};